import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MonthlyLunchMenuChoices } from '../meal-service.model';

@Component({
  selector: 'app-lunch-menu-choices',
  templateUrl: './lunch-menu-choices.component.html',
  styles: []
})
export class LunchMenuChoicesComponent implements OnInit {

  isBusy: boolean = false;
  selectedChoice: MonthlyLunchMenuChoices[] = [];
  transactionDate: Date;

  constructor(
    private dialogRef: MatDialogRef<LunchMenuChoicesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.transactionDate = this.data.Date;
    this.selectedChoice = this.data.MonthlyLunchMenuChoices;
  }

  closeClick() {
    this.dialogRef.close('Cancel was clicked.');
  }
}
